var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 11 13",
    style: {
      enableBackground: "new 0 0 11 13"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 5.3,
    cy: 4.1,
    r: 4.1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.9,9.5H1.8c-1,0-1.8,0.8-1.8,1.8V13h10.6v-1.8C10.6,10.3,9.8,9.5,8.9,9.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 5.3,
    cy: 4.1,
    r: 4.1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.9,9.5H1.8c-1,0-1.8,0.8-1.8,1.8V13h10.6v-1.8C10.6,10.3,9.8,9.5,8.9,9.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIUser);
export default __webpack_public_path__ + "static/media/i_user.deddfe24428133db42438d8a18b65ec0.svg";
export { ForwardRef as ReactComponent };